import { axiosService } from "./axiosService";

const shopApi = {
    getShops() {
        const url = '/shop';
        return axiosService.get(url)
    },
    createShop(body) {
        const url = '/shop';
        return axiosService.post(url, body)
    },
    updateShop(id, body) {
        const url = `/shop/${id}`;
        return axiosService.put(url, body)
    },
    deleteShop(id) {
        const url = `/shop/${id}`;
        return axiosService.delete(url)
    },
    getShopByRole(params) {
        const url = '/shop-by-role';
        return axiosService.get(url, { params })
    }
}

export default shopApi;